package ui.app.assign.detail.wheel.preview.pages

import androidx.compose.foundation.VerticalScrollbar
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollbarAdapter
import androidx.compose.foundation.shape.AbsoluteCutCornerShape
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedCard
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import common.frontend.api.Io
import tk.mallumo.utils.DataState
import tools.formatFromRes
import ui.app.assign.detail.wheel.preview.AppPreviewWheelScope
import ui.widget.ErrUI
import ui.widget.LazyIcon
import ui.widget.LazyImage
import ui.widget.LoadingUI

@Composable
fun AppPreviewWheelScope.AppWheelHistory(modifier: Modifier) {

    Box(modifier.fillMaxSize()) {
        when (val state = vm.stateHistory) {
            is DataState.Idle<*>,
            is DataState.Loading<*> -> LoadingUI()

            is DataState.Error<*> -> ErrUI()
            is DataState.Result<Io.WheelHistoryOverview> -> ContentUI(state.nnvl)
        }

    }
}

@Composable
private fun AppPreviewWheelScope.ContentUI(nnvl: Io.WheelHistoryOverview) {
    Box(Modifier.fillMaxSize()) {

        if (nnvl.items.isEmpty()) {

            Text(
                text = "No history",
                modifier = Modifier.align(Alignment.Center)
            )
        } else {
            val state = rememberLazyListState()
            LazyColumn(
                state = state,
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.spacedBy(4.dp),
                contentPadding = PaddingValues(8.dp)
            ) {
                items(nnvl.items) {
                    Item(it)
                }
            }
            VerticalScrollbar(
                modifier = Modifier.fillMaxHeight()
                    .align(Alignment.CenterEnd)
                    .padding(2.dp),
                adapter = rememberScrollbarAdapter(state)
            )
        }
    }
}


@Composable
private fun AppPreviewWheelScope.Item(entry: Io.WheelHistoryOverview.Entry) {
    OutlinedCard(
        shape = AbsoluteCutCornerShape(8.dp),
        colors = CardDefaults.outlinedCardColors(
            containerColor = Color(entry.item.color.surface),
            contentColor = Color(entry.item.color.onSurface),
        )
    ) {
        Column(
            modifier = Modifier.padding(8.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Row(
                Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                when {
                    entry.item.icon.svg > 0 -> {
                        LazyIcon(
                            id = entry.item.icon.svg,
                            modifier = Modifier.size(24.dp).align(Alignment.CenterVertically),
                            tint = Color(entry.item.color.onSurface)
                        )
                    }

                    entry.item.icon.webp > 0 -> {
                        LazyImage(
                            id = entry.item.icon.webp,
                            modifier = Modifier.size(24.dp).align(Alignment.CenterVertically),
                            alphaBackground = false
                        )
                    }
                }
                Text(
                    text = entry.item.name.trim(),
                    maxLines = 1,
                    overflow = TextOverflow.Clip,
                    modifier = Modifier.weight(1F)
                )
                Text(entry.dt.formatFromRes())
            }
            Text(
                text = entry.code,
                style = MaterialTheme.typography.bodySmall,
                fontWeight = FontWeight.Bold
            )
        }
    }

}